module.exports = __webpack_public_path__ + "static/media/waage.a0043e6a.svg";